import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
export var NewBrandsFreeShippingBanner = function() {
    var layoutElement = React.useContext(Context).layoutElement;
    var images = layoutElement.images, main_text = layoutElement.main_text, main_text_color = layoutElement.main_text_color, tagline_text = layoutElement.tagline_text, tagline_text_color = layoutElement.tagline_text_color, description_text_color = layoutElement.description_text_color, description_text = layoutElement.description_text;
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            images[0] ? /*#__PURE__*/ _jsx(BannerImage, {
                $backgroundUrl: optimizeImageUrl(images[0], isSSR, {
                    width: 600
                })
            }) : null,
            /*#__PURE__*/ _jsxs(Content, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "labelSansMedium",
                        color: main_text_color,
                        children: main_text
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "pageHeaderSerifRegular",
                        color: description_text_color,
                        children: description_text
                    }),
                    tagline_text ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: {
                                    mobileAndAbove: "2x",
                                    tabletAndAbove: "1x"
                                }
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansRegular",
                                color: tagline_text_color,
                                children: tagline_text
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var Wrapper = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-7f80502e-0"
})([
    "margin-bottom:",
    ";background-color:",
    ";",
    "{height:140px;}"
], getSpacing("3x"), Decorative.tint.orange, responsiveMediaQueries.tabletAndAbove);
var Content = styled(Column).withConfig({
    componentId: "sc-7f80502e-1"
})([
    "width:100%;height:100%;padding:",
    ";"
], getSpacing("3x", "4x"));
var BannerImage = styled.div.withConfig({
    componentId: "sc-7f80502e-2"
})([
    "width:100%;background-image:url(",
    ");background-size:cover;background-position:center;",
    "{width:30%;height:auto;}"
], function(props) {
    return props.$backgroundUrl;
}, responsiveMediaQueries.tabletAndAbove);
